import { Component, OnInit } from '@angular/core';
import { DashboardPreContentieuxService } from '../../core/service/suiviPortefeuille/dashboard-pre-contentieux.service';
import { first } from "rxjs/operators";
import { ChartViewDTO } from '../../core/model/chart_view/chart-view-dto';
import * as Highcharts from "highcharts";
import { DashboardPortefeuilleRisqueService } from '../../core/service/suiviPortefeuille/dashboard-portefeuille-risque.service';
import { QuantiteDossierParMarcheEntrePeriodeDTO } from '../../core/model/QuantiteDossierParMarcheEntrePeriodeDTO';
import { QuantiteDossierPrecontentieuxDTO } from '../../core/model/QuantiteDossierPrecontentieuxDTO';

@Component({
  selector: "app-pre-contentieux",
  templateUrl: "./pre-contentieux.component.html",
  styleUrls: ["./pre-contentieux.component.scss"]
})
export class PreContentieuxComponent implements OnInit {
  highcharts = Highcharts;

  nombreByPeriode: ChartViewDTO;
  chartOptionsSuiviByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  chartOptionsQuantiteByPeriode: any;
  quantiteDossierPrecontentieuxDTO: QuantiteDossierPrecontentieuxDTO[];

  constructor(
    private _dashboardPreContentieuxService: DashboardPreContentieuxService
  ) {}

  ngOnInit() {
    this.nombrePreContentieuxFiltrerSurPeriode();
    this.quantitePreContentieuxSurLes6DerniersMois();
    this.quantiteDossierPrecontentieux();
  }

  nombrePreContentieuxFiltrerSurPeriode() {
    this._dashboardPreContentieuxService
      .nombrePreContentieuxFiltrerSurPeriode("_", "_")
      .pipe(first())
      .subscribe(
        response => {
          this.nombreByPeriode = response;

          this.chartOptionsSuiviByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text:
                "Evolution des dossiers au précontentieux et contentieux sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.nombreByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Jour(s)"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.nombreByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantitePreContentieuxSurLes6DerniersMois() {
    this._dashboardPreContentieuxService
      .quantitePreContentieuxSurLes6DerniersMois("_", "_")
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text:
                "Evolution des dossiers au pré-contentieux par marché sur les 6 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierPrecontentieux() {
    this._dashboardPreContentieuxService
      .quantiteDossierPrecontentieux()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteDossierPrecontentieuxDTO = response;
        },
        error => {
          console.log(error);
        }
      );
  }
}
